/**
 * Admin Log Repository
 * 관리자 로그 데이터 액세스 계층
 */

import axios from 'axios';
import { API_BASE_URL } from '../../../config/api';
import {
  AdminLog,
  AdminLogStats,
  AdminLogQueryParams,
} from '../models';

export class AdminLogRepository {
  private baseUrl = `${API_BASE_URL}/api/v1/admin/logs`;

  private getAuthHeaders() {
    const token = localStorage.getItem('admin_token');
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async getLogs(params?: AdminLogQueryParams): Promise<AdminLog[]> {
    const response = await axios.get(this.baseUrl, {
      headers: this.getAuthHeaders(),
      params,
    });
    return response.data;
  }

  async getMyLogs(limit?: number): Promise<AdminLog[]> {
    const response = await axios.get(`${this.baseUrl}/my-logs`, {
      headers: this.getAuthHeaders(),
      params: { limit },
    });
    return response.data;
  }

  async getLogsByEntity(entityType: string, entityId: string): Promise<AdminLog[]> {
    const response = await axios.get(`${this.baseUrl}/entity/${entityType}/${entityId}`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async getLogStats(days?: number): Promise<AdminLogStats> {
    const response = await axios.get(`${this.baseUrl}/stats`, {
      headers: this.getAuthHeaders(),
      params: { days },
    });
    return response.data;
  }

  async cleanupOldLogs(days: number): Promise<{ deleted_count: number }> {
    const response = await axios.delete(`${this.baseUrl}/cleanup`, {
      headers: this.getAuthHeaders(),
      params: { days },
    });
    return response.data;
  }
}
